webpackJsonp([183400410456155],{

/***/ 70:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(48);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _PostListingModule = __webpack_require__(80);
	
	var _PostListingModule2 = _interopRequireDefault(_PostListingModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PostListing = function (_React$Component) {
	  _inherits(PostListing, _React$Component);
	
	  function PostListing() {
	    _classCallCheck(this, PostListing);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  PostListing.prototype.getPostList = function getPostList() {
	    var postList = [];
	    this.props.postEdges.forEach(function (postEdge) {
	      postList.push({
	        path: postEdge.node.fields.slug,
	        tags: postEdge.node.frontmatter.tags,
	        cover: postEdge.node.frontmatter.cover,
	        title: postEdge.node.frontmatter.title,
	        date: postEdge.node.frontmatter.date,
	        excerpt: postEdge.node.excerpt,
	        timeToRead: postEdge.node.timeToRead
	      });
	    });
	    return postList;
	  };
	
	  PostListing.prototype.render = function render() {
	    var postList = this.getPostList();
	    return _react2.default.createElement(
	      "div",
	      { className: _PostListingModule2.default.postlistcontainer },
	      /* Your post list here. */
	      postList.map(function (post) {
	        return _react2.default.createElement(
	          "article",
	          { className: _PostListingModule2.default.articleexcerpt },
	          _react2.default.createElement(
	            "div",
	            { className: "row" },
	            _react2.default.createElement(
	              "div",
	              { className: "col-md-4 d-flex align-self-stretch" },
	              _react2.default.createElement("img", { src: post.cover, alt: post.title, className: "img-fluid d-flex align-self-center" })
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "col-md-8" },
	              _react2.default.createElement(
	                "span",
	                { className: "date" },
	                post.date.substr(6, 2) + "/" + post.date.substr(4, 2) + "/" + post.date.substr(0, 4)
	              ),
	              _react2.default.createElement(
	                _gatsbyLink2.default,
	                { to: post.path, key: post.title },
	                _react2.default.createElement(
	                  "h1",
	                  null,
	                  post.title
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { "class": _PostListingModule2.default.postexcerpt },
	                post.excerpt
	              ),
	              _react2.default.createElement(
	                "div",
	                { "class": _PostListingModule2.default.postshowmore },
	                _react2.default.createElement(
	                  "a",
	                  { href: post.path, className: "btn btn-primary", title: post.title },
	                  "Lire la suite"
	                )
	              )
	            )
	          )
	        );
	      })
	    );
	  };
	
	  return PostListing;
	}(_react2.default.Component);
	
	exports.default = PostListing;
	module.exports = exports["default"];

/***/ }),

/***/ 80:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"postlistcontainer":"src-components-PostListing----PostListing-module---postlistcontainer---2Lgyv","articleexcerpt":"src-components-PostListing----PostListing-module---articleexcerpt---284tc"};

/***/ }),

/***/ 183:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/tags.4d79052a.jpg";

/***/ }),

/***/ 330:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(10);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _PostListing = __webpack_require__(70);
	
	var _PostListing2 = _interopRequireDefault(_PostListing);
	
	var _SiteConfig = __webpack_require__(6);
	
	var _SiteConfig2 = _interopRequireDefault(_SiteConfig);
	
	var _SEO = __webpack_require__(14);
	
	var _SEO2 = _interopRequireDefault(_SEO);
	
	var _HeaderPage = __webpack_require__(15);
	
	var _HeaderPage2 = _interopRequireDefault(_HeaderPage);
	
	var _Header = __webpack_require__(12);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Menu = __webpack_require__(13);
	
	var _Menu2 = _interopRequireDefault(_Menu);
	
	var _Footer = __webpack_require__(11);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _tags = __webpack_require__(183);
	
	var _tags2 = _interopRequireDefault(_tags);
	
	var _tagsModule = __webpack_require__(440);
	
	var _tagsModule2 = _interopRequireDefault(_tagsModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TagTemplate = function (_React$Component) {
	  _inherits(TagTemplate, _React$Component);
	
	  function TagTemplate() {
	    _classCallCheck(this, TagTemplate);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  TagTemplate.prototype.render = function render() {
	    var tag = this.props.pathContext.tag;
	    var postEdges = this.props.data.allMarkdownRemark.edges;
	    var slug = this.props.pathContext.slug;
	
	    var postNode = {
	      "frontmatter": {
	        "title": { tag: tag },
	        "description": "Les actualit\xE9s g\xE9n\xE9rales et techniques \xE0 propos de \"" + tag + "\" du monde web",
	        "cover": ""
	      }
	    };
	
	    var title = tag;
	    var description = "";
	
	    return _react2.default.createElement(
	      "div",
	      { className: _tagsModule2.default.tagcontainer },
	      _react2.default.createElement(_reactHelmet2.default, { title: "Les actualit\xE9s \"" + tag + "\" | " + _SiteConfig2.default.siteTitle }),
	      _react2.default.createElement(_SEO2.default, { postPath: slug, postNode: postNode, postSEO: true }),
	      _react2.default.createElement(_Menu2.default, null),
	      _react2.default.createElement(_Header2.default, null),
	      _react2.default.createElement(_HeaderPage2.default, { title: title, description: description, picture: _tags2.default }),
	      _react2.default.createElement(
	        "section",
	        { className: "container" },
	        _react2.default.createElement(
	          "p",
	          { className: "text-center " + _tagsModule2.default.summary },
	          "D\xE9couvrez tous nos articles \xE0 propos de la cat\xE9gorie ",
	          _react2.default.createElement(
	            "strong",
	            null,
	            tag
	          ),
	          "."
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: _tagsModule2.default.postlist },
	          _react2.default.createElement(_PostListing2.default, { postEdges: postEdges })
	        )
	      ),
	      _react2.default.createElement(_Footer2.default, null)
	    );
	  };
	
	  return TagTemplate;
	}(_react2.default.Component);
	
	/* eslint no-undef: "off"*/
	
	
	exports.default = TagTemplate;
	var pageQuery = exports.pageQuery = "** extracted graphql fragment **";

/***/ }),

/***/ 440:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"tag-container":"src-templates----tags-module---tag-container---3o_ft","summary":"src-templates----tags-module---summary---1hL2M"};

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-tag-jsx-11d9931573ad8d501695.js